import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { supabase, isSupabaseConfigured } from "../lib/supabaseClient";

const AUTH_STORAGE_KEY = "modelerman_admin_auth";
const VALID_USERNAME = process.env.REACT_APP_ADMIN_USERNAME || "admin";
const VALID_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || "mehmet1234";

const AdminAuthContext = createContext(undefined);

const readInitialAuthState = () => {
  try {
    return typeof window !== "undefined" && window.localStorage.getItem(AUTH_STORAGE_KEY) === "true";
  } catch (error) {
    console.warn("Admin auth storage okunamadı", error);
    return false;
  }
};

export function AdminAuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(readInitialAuthState);

  useEffect(() => {
    if (isAuthenticated) {
      window.localStorage.setItem(AUTH_STORAGE_KEY, "true");
    } else {
      window.localStorage.removeItem(AUTH_STORAGE_KEY);
    }
  }, [isAuthenticated]);

  const validateCredentials = async (username, password) => {
    const normalizedUsername = username?.trim();
    if (normalizedUsername === VALID_USERNAME && password === VALID_PASSWORD) {
      if (isSupabaseConfigured && supabase) {
        try {
          await supabase.auth.signInWithPassword({
            email: normalizedUsername,
            password,
          });
        } catch (authError) {
          console.error("Supabase admin oturumu açılamadı", authError);
          return {
            success: false,
            message: "Supabase oturumu açılamadı. Kullanıcı bilgilerini kontrol edin.",
          };
        }
      }

      setIsAuthenticated(true);
      return { success: true };
    }

    return {
      success: false,
      message: "Kullanıcı adı veya şifre hatalı.",
    };
  };

  const logout = async () => {
    if (isSupabaseConfigured && supabase) {
      try {
        await supabase.auth.signOut();
      } catch (signOutError) {
        console.warn("Supabase admin oturumu kapatılamadı", signOutError);
      }
    }
    setIsAuthenticated(false);
  };

  const value = useMemo(
    () => ({
      isAuthenticated,
      validateCredentials,
      logout,
    }),
    [isAuthenticated]
  );

  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
}

export function useAdminAuth() {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error("useAdminAuth, AdminAuthProvider içinde kullanılmalıdır.");
  }
  return context;
}
